import { Button, Col, Layout, message, Row, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import LockIcon from "../../../assets/icons/lock-grey.svg";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import DatePickerComponent from "../../../components/DatePickerComponent";
import InputComponent from "../../../components/InputComponent";
import PhoneInputComponent from "../../../components/PhoneInputCompnent";
import { CREATOR, FAN, REQUEST_LOADING_STATES } from "../../../helpers/constant";
import { defaultEditPersonalInfosRequest, IEditPersonalInfosRequest } from "../../../helpers/requests";
import useFetchUserInfos from "../../../hooks/userHooks/useFetchUserInfos";
import { AppDispatch, StoreState } from "../../../redux/store";
import { clearLAEData, updateUserInfos } from "../../../redux/users/usersSlice";
import { isDOBPlus18, validateEmail, validatePhoneNumber } from "../../../utls/FunctionsUtil";
import BecomeCreator from "./BecomeCreator";
import BecomeProfessional from "./BecomeProfessional";
import "./index.less";

const PersonalInformationsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { currentUser: user } = useFetchUserInfos(true);
  const { loading, error, action} = useSelector((state: StoreState) => state.users);
  const [personalInfos, setPersonalInfos] = useState<IEditPersonalInfosRequest>(defaultEditPersonalInfosRequest);


  useEffect(() => {
    if(user?.infos.privateInfos) {
      setPersonalInfos(user.infos.privateInfos);
    }
  }, [user]);

  useEffect(() => {
    if(loading === REQUEST_LOADING_STATES.SUCCEEDED && action === "updateProfile") {
      message.success(t("updated-personal-information-successfully"));
      dispatch(clearLAEData());
    }

    if(loading === REQUEST_LOADING_STATES.FAILED && error && action === "updateProfile") {
      message.error(t(error));
      dispatch(clearLAEData());
    }

  }, [loading, error, action, t, dispatch]);

  const phoneCodeChanged = (phoneCode: string, countryCode: string) => {
    setPersonalInfos({ ...personalInfos, phoneCode, countryCode });
  };

  const handleOnChange = (name: string, value: string) => {
    if (name === "dateOfBirth" && value && !isDOBPlus18(value)) {
      message.warning(t("minimum-age"));
      return;
    }
    setPersonalInfos({ ...personalInfos, [name]: value });
  };

  const registerClicked = async () => {
    if (!validateEmail(personalInfos.email!)) {
      message.error(t("email-invalid"));
      return;
    }

    dispatch(updateUserInfos(personalInfos));
  };



  const handleBtnDisabled = () => {
    return !personalInfos.dateOfBirth || !personalInfos.email || !personalInfos.phone;
  };

  return (
    <Layout>
      <Layout.Content className="content creatorPersonalInformationContentWrapper gradient-background">
        <Row className="relative justify-content-center header-title-container-60">
          <ArrowLeftIconComponent left={-5} top={1} />
          <Typography.Text className="ml-20 header-title-black-20">{t("personal-information")}</Typography.Text>
        </Row>
        <Row className="mt-20">
          <Space className="w-full gap-13" direction="vertical">
            <Row gutter={7} align="middle">
              <Col span={12}>
                <Space className="w-full gap-6" direction="vertical">
                  <Typography.Text className="font-16-bold text-white-color">{t("identity")}</Typography.Text>
                  <InputComponent
                    className="darkInput"
                    type="text"
                    value={user?.infos.firstName || ""}
                    suffix={<img src={LockIcon} alt="lock" />}
                    disabled={true}
                  />
                </Space>
              </Col>
              <Col className="mt-25" span={12}>
                <Space className="w-full gap-6" direction="vertical">
                  <InputComponent
                    className="darkInput"
                    type="text"
                    value={user?.infos.lastName || ""}
                    suffix={<img src={LockIcon} alt="lock" />}
                    disabled={true}
                  />
                </Space>
              </Col>
            </Row>
            <Row>
              <Space className="w-full gap-6" direction="vertical">
                <Typography.Text className="font-16-bold text-white-color">{t("user-name-label")}</Typography.Text>
                <InputComponent
                  className="darkInput"
                  type="text"
                  value={user?.infos.username || ""}
                  suffix={<img src={LockIcon} alt="lock" />}
                  disabled={true}
                />
              </Space>
            </Row>
            <Row>
              <Space className="w-full gap-6" direction="vertical">
                <Typography.Text className="font-16-bold text-white-color">{t("date-of-birth-label")}</Typography.Text>
                <DatePickerComponent
                  className="darkDatePickerSignup"
                  date={personalInfos.dateOfBirth || ""}
                  name="dateOfBirth"
                  onChange={(value) => handleOnChange("dateOfBirth", value || '')}
                />
              </Space>
            </Row>
            <Row>
              <Space className="w-full gap-6" direction="vertical">
                <Typography.Text className="font-16-bold text-white-color">{t("email-label")}</Typography.Text>
                <InputComponent className="darkInput" type="email" name="email" value={personalInfos.email || ""} onChange={e => handleOnChange("email", e.target.value)} />
              </Space>
            </Row>
            <Row className="creator-phone-details">
              <Space className="w-full gap-6" direction="vertical">
                <Typography.Text className="font-16-bold text-white-color">{t("phone-number-label")}</Typography.Text>
                <PhoneInputComponent
                  className="authDark"
                  countryCode={personalInfos.countryCode}
                  phoneCode={personalInfos.phoneCode}
                  phone={personalInfos.phone}
                  onChangePhone={(e) => handleOnChange("phone", e.target.value)}
                  onChangePhoneCode={(phoneCode, countryCode) => {
                    phoneCodeChanged(phoneCode, countryCode);
                  }}
                />
              </Space>
            </Row>
            {user?.infos.type === FAN && <BecomeCreator t={t}/>}
            {user && user.infos.type === CREATOR && <BecomeProfessional t={t} user={user.infos} />}
          </Space>
        </Row>

        <Row className="mt-58">
          <Button disabled={handleBtnDisabled()} className="saveBtn" onClick={registerClicked}>
            {t("register")}
          </Button>
        </Row>
      </Layout.Content>
      {/* <FooterComponent type="creator" page={FOOTER_IDS.PROFILE} /> */}
    </Layout>
  );
};

export default PersonalInformationsPage;
